import { useState, useEffect } from 'react';
import config from '../../config';

export const useRejectedDocumentsCount = () => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const authUser = sessionStorage.getItem('authUser');
        if (!authUser) {
          setLoading(false);
          return;
        }
        
        const { token } = JSON.parse(authUser);
        const response = await fetch(`${config.api.API_URL}/my-documents?status=rejected&limit=1`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          setCount(data.data.stats?.rejected || 0);
        }
      } catch (error) {
        console.error('Error fetching rejected documents count:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCount();
    
    // Refresh count every 60 seconds
    const interval = setInterval(fetchCount, 60000);
    
    return () => clearInterval(interval);
  }, []);

  return { count, loading };
};

export default useRejectedDocumentsCount;